export const DELIVERY = 'multiple_recipient_lock.delivery';
export const PICKUP = 'multiple_recipient_lock.pickup';
export const MENU_TITLE = 'multiple_recipient_lock.menu_title';
export const GUIDE = 'multiple_recipient_lock.guide';
export const NEW_RECIPIENT_SUBTITLE =
  'multiple_recipient_lock.new_recipient_subtitle';
export const SWITCH_RECIPIENT = 'multiple_recipient_lock.switch_recipient';
export const CLOSE = 'multiple_recipient_lock.close';
